import React from 'react';
import classnames from 'classnames';
import styles from './QuickReplyButtonsBlock.module.scss';
const QuickReplyButtonsBlock = ({ messageBlock, error, background, customColor }) => (React.createElement("div", { className: styles.buttonsBlock }, messageBlock.buttons.map((button, i) => (React.createElement("button", { key: i, className: classnames(styles.button, { [styles.error]: error }), style: { background }, disabled: true },
    React.createElement("p", { className: styles.text, style: { color: customColor } }, button.text))))));
export default QuickReplyButtonsBlock;
